import React from "react";
import Image from "components/image";

const ImageModule = ({ data }) => (
	<>
		<Image image={data.desktopImage} className="!hidden md:!block -mt-0.5" />
		<Image image={data.mobileImage} className="md:!hidden -mt-0.5" />
	</>
);

export default ImageModule;